let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("9eNkX"), load("k10Cs"), load("dh2Er"), load("l6YHr")]).then(() => parcelRequire('dFo9j'));